import { defineComponent as _defineComponent } from 'vue'
import { computed, unref, toRefs } from 'vue';
    import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';
    import FiltersListSectionMobile from '@ve/components/searchFilters/filterList/mobile/FiltersListSection.vue';
    import FilterListRenderMobile from '@ve/components/filters/common/components/FilterListRender/mobile/FilterListRender.vue';
    import FilterListRenderDesktop from '@fr/vue/components/filters/common/components/FilterListRender/FilterListRender.vue';
    import FilterPostWrapper from '@fr/vue/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
    import FiltersListSectionDesktop from '@fr/vue/components/searchFilters/filterList/desktop/FiltersListSection.vue';
    import FilterAttributeMethodsPrepayments from '../lib/FilterAttributeMethodsPrepayments';
    import usePrepaymentFilterModel from '../lib/usePrepaymentFilterModel';

    interface IFilterPrepaymentsProps {
        grouppedFilteredPrepayments: IFirstPaymentDefinition[][],
        grouppedAllPrepayments: IFirstPaymentDefinition[][],
        prepaymentsList: IFirstPaymentDefinition[],
        visibleCounter?: boolean,
        isMobile?: boolean; 
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PrepaymentsFilterAttributes',
  props: {
    grouppedFilteredPrepayments: null,
    grouppedAllPrepayments: null,
    prepaymentsList: null,
    visibleCounter: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { grouppedFilteredPrepayments: IFirstPaymentDefinition[][], grouppedAllPrepayments: IFirstPaymentDefinition[][], prepaymentsList: IFirstPaymentDefinition[], visibleCounter: boolean, isMobile: boolean }

    

    const { selectedPrepayments } = usePrepaymentFilterModel();

    const filterAttributesMethodsPrepayments = computed(() => new FilterAttributeMethodsPrepayments(props.prepaymentsList));

    const isLeastOneGroupHasPrepayment = computed(() => unref(filterAttributesMethodsPrepayments)?.isOneEntityHasProperty(props.grouppedAllPrepayments));



return { __sfc: true,props, selectedPrepayments, filterAttributesMethodsPrepayments, isLeastOneGroupHasPrepayment, FiltersListSectionMobile, FilterListRenderMobile, FilterListRenderDesktop, FilterPostWrapper, FiltersListSectionDesktop }
}

})